import { render, staticRenderFns } from "./AdmitDownload.vue?vue&type=template&id=ab8c79bc&scoped=true&"
import script from "./AdmitDownload.vue?vue&type=script&lang=js&"
export * from "./AdmitDownload.vue?vue&type=script&lang=js&"
import style0 from "./AdmitDownload.vue?vue&type=style&index=0&id=ab8c79bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8c79bc",
  null
  
)

export default component.exports